/**
 * Shared model lists for eval and source analysis features.
 */

/** Models available for running evals and source analysis. */
export const EVAL_MODELS = [
  'meta-llama/llama-3.2-3b-instruct',
  'mistralai/mistral-7b-instruct',
  'meta-llama/llama-3.1-8b-instruct',
  'mistralai/mistral-nemo',
  'google/gemma-3n-e4b-it',
  'mistralai/mistral-small-3.1-24b-instruct',
  'mistralai/mistral-small-3.2-24b-instruct',
  'google/gemini-2.5-flash',
  'google/gemini-2.5-flash-lite',
  'meta-llama/llama-4-scout',
  'qwen/qwen3-8b',
  'deepseek/deepseek-chat-v3-0324',
  'anthropic/claude-haiku-4.5',
  'anthropic/claude-sonnet-4',
  'anthropic/claude-opus-4',
  'openai/gpt-4o-mini',
  'openai/gpt-oss-120b',
  'liquid/lfm2-8b-a1b',
];

/** Models available for source analysis (all via OpenRouter). */
export const ANALYSIS_MODELS = [
  ...EVAL_MODELS.map(id => ({id, label: id.split('/').pop()!, provider: 'openrouter'})),
];

/** Short display name for a model ID. */
export function shortModelName(id: string): string {
  return id.split('/').pop() || id;
}
